import * as React from 'react';
import { TextField, Popper, Fade, Box, Typography, ClickAwayListener, InputAdornment, IconButton, CircularProgress } from '@mui/material';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

export default function SelectPopup(props) {

    const isFetched = React.useRef(false);
    const { children, placeholder, onChange, disabled = false, value, onFocus, errors, loading } = props;
    const [open, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [disableClickAway, setDisableClickAway] = React.useState(false);

    const handleClose = () => {
        if (!disableClickAway) {
            setOpen(false);
        }
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(!open);
        if (!isFetched.current) {
            onFocus();
            isFetched.current = true;
        };

        setDisableClickAway(!open);
        setTimeout(() => setDisableClickAway(open), 100);
    };

    const canBeOpen = open && Boolean(anchorEl);
    const id = canBeOpen ? 'transition-popper' : undefined;

    return (
        <Box>
            <>
                <Typography variant="h7">{placeholder}</Typography>
                <TextField
                    aria-describedby={id}
                    size="small"
                    sx={{
                        '& .MuiInputBase-root': {
                            paddingRight: 1
                        }
                    }}
                    value={value}
                    disabled={disabled}
                    slotProps={{
                        input: {
                            readOnly: true,
                        },
                    }}
                    onClick={handleClick}
                    error={!!errors}
                    helperText={errors?.message}
                    onChange={(e) => onChange(e.target.value)}
                    InputProps={{
                        readOnly: true,
                        endAdornment: (
                            <InputAdornment position="end" sx={{ padding: 0 }}>
                                <IconButton sx={{ padding: '3px' }}>
                                    {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </>
            <ClickAwayListener onClickAway={handleClose}>
                <Popper id={id} open={open} anchorEl={anchorEl} transition placement={'bottom-end'} sx={{ zIndex: 10004, backgroundColor: 'transparent' }}>
                    {({ TransitionProps }) => (
                        <Fade {...TransitionProps} timeout={350}>
                            <Box sx={{
                                bgcolor: 'background.paper',
                                marginTop: '5px',
                                borderRadius: '12px',
                                padding: '5px',
                                border: '1px solid #e0e0e0',
                                minHeight: '200px',
                                minWidth: '300px',
                                position: 'relative'
                            }}>
                                {loading &&
                                    <Box sx={{
                                        height: '90%',
                                        width: '95%',
                                        position: 'absolute',
                                        backdropFilter: "blur(3px)",
                                        zIndex: 1,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}><CircularProgress size={50} /></Box>
                                }
                                {children}
                            </Box>
                        </Fade>
                    )}
                </Popper>
            </ClickAwayListener>
        </Box>
    );
}
